import { useState } from 'react';

import Text from '@ui/text/text/text';
import SettingsEditPanel from '../../controls/settings-edit-panel';

import SiteDetail from './site-detail';
import SiteSearchPreviewModal from './site-search-preview-modal';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { selectProjectName, selectWorkingProjectDescription } from '@/store/slices/project/selectors';
import { selectSocialSharingSettings } from '@/store/slices/settings/selectors';

const SiteDetailWidget = () => {
  const projectName = useAppSelector(selectProjectName);
  const projectDescription = useAppSelector(selectWorkingProjectDescription);
  const sharingSettings = useAppSelector(selectSocialSharingSettings);

  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [metadata, setMetadata] = useState({
    name: sharingSettings?.name || projectName || '',
    description: sharingSettings?.description || projectDescription || '{{Project description}}',
  });

  const dispatch = useAppDispatch();

  const handleSave = () => {
    const social_sharing = {
      ...sharingSettings,
      description: metadata.description,
      name: metadata.name,
    };
    dispatch(
      saveWorkingProjectByFields({
        social_sharing,
        saveId: 'settings-social-sharing',
      })
    );
    setIsEditing(false);
  };

  const handleCancel = () => {
    setMetadata({
      name: sharingSettings?.name || projectName || '',
      description: sharingSettings?.description || projectDescription || '{{Project description}}',
    });
    setIsEditing(false);
  };

  return (
    <>
      <div className="flex-column gap-8">
        <Text className="H5" color="var(--gray-100)">
          Site Details
        </Text>
        <SettingsEditPanel
          isEditing={isEditing}
          onCancel={handleCancel}
          onSave={handleSave}
          onPreview={() => setPreviewModalOpen((prev) => !prev)}
        >
          <SiteDetail
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            metadata={metadata}
            setMetaData={setMetadata}
            setPreviewModalOpen={setPreviewModalOpen}
          />
        </SettingsEditPanel>
      </div>
      <SiteSearchPreviewModal
        open={previewModalOpen}
        handleClose={() => setPreviewModalOpen((prev) => !prev)}
        metadata={metadata}
      />
    </>
  );
};

export default SiteDetailWidget;
